// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ejd3vCJJ1kW0bIB6GNEM h1 + p {
    color: #8c8c8c;
    margin: -9px 0 26px 0;
    font-size: 14px;
}

.mOa_hNGBwOetzmse0vdz {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 50px;
}

.clxIxHbt5PfBeT7hzLXj {
    display: flex;
    padding: 20px;
    margin-bottom: 30px;
    border: 1px solid #bbbbbb;
    border-radius: 3px;
}

.jdj9wBrUX9gGFNbBpaXM {
    min-width: 100px;
}

.JB5xD29KyHdWXDZoBqkP {
    width: 50px;
    display: flex;
    vertical-align: middle;
    justify-content: center;
}

.JB5xD29KyHdWXDZoBqkP button {
    margin-right: -20px;
    padding-top: 20px;
}

.tFEu7wQyyQusXX_tUolQ {
    display: block;
    max-width: 220px;
    font-size: 14px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
}

.lOF5h0Z_go5XRjNUWNA_ {
    margin: 8px 0;
}

@keyframes UdEntJ41yR3QVkpOgEsg {
    0%{
        background-position: -100vw 0
    }

    100%{
        background-position: 100vw 0
    }
}

.UdEntJ41yR3QVkpOgEsg {
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: UdEntJ41yR3QVkpOgEsg;
    animation-timing-function: linear;
    background: linear-gradient(to right, white 8%, #dddddd 18%, white 33%);
    background-size: 100vw 1px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/clients/documents/upload/styles.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,mCAAmC;IACnC,oCAAuB;IACvB,iCAAiC;IACjC,uEAAuE;IACvE,0BAA0B;AAC9B","sourcesContent":[".container h1 + p {\n    color: #8c8c8c;\n    margin: -9px 0 26px 0;\n    font-size: 14px;\n}\n\n.fileRows {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-top: 50px;\n}\n\n.fileRowContainer {\n    display: flex;\n    padding: 20px;\n    margin-bottom: 30px;\n    border: 1px solid #bbbbbb;\n    border-radius: 3px;\n}\n\n.fileRowLeft {\n    min-width: 100px;\n}\n\n.fileRowRight {\n    width: 50px;\n    display: flex;\n    vertical-align: middle;\n    justify-content: center;\n}\n\n.fileRowRight button {\n    margin-right: -20px;\n    padding-top: 20px;\n}\n\n.filename {\n    display: block;\n    max-width: 220px;\n    font-size: 14px;\n    font-weight: 600;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.select {\n    margin: 8px 0;\n}\n\n@keyframes shimmer {\n    0%{\n        background-position: -100vw 0\n    }\n\n    100%{\n        background-position: 100vw 0\n    }\n}\n\n.shimmer {\n    animation-duration: 2s;\n    animation-fill-mode: forwards;\n    animation-iteration-count: infinite;\n    animation-name: shimmer;\n    animation-timing-function: linear;\n    background: linear-gradient(to right, white 8%, #dddddd 18%, white 33%);\n    background-size: 100vw 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ejd3vCJJ1kW0bIB6GNEM`,
	"fileRows": `mOa_hNGBwOetzmse0vdz`,
	"fileRowContainer": `clxIxHbt5PfBeT7hzLXj`,
	"fileRowLeft": `jdj9wBrUX9gGFNbBpaXM`,
	"fileRowRight": `JB5xD29KyHdWXDZoBqkP`,
	"filename": `tFEu7wQyyQusXX_tUolQ`,
	"select": `lOF5h0Z_go5XRjNUWNA_`,
	"shimmer": `UdEntJ41yR3QVkpOgEsg`
};
export default ___CSS_LOADER_EXPORT___;
